import React from 'react'
import { Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

import { useTranslation } from '../../../../common/hooks/helper/useTranslation'

type Props = {
  patient: { title: string; firstName: string; lastName: string }
}

const useStyles = makeStyles((theme) => ({
  patientName: {
    [theme.breakpoints.down('md')]: {
      fontSize: '1.4rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
    },
  },
}))

const PatientHeadlineInfo: React.FC<React.PropsWithChildren<Props>> = ({
  patient,
}) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Typography
      py={1}
      px={2}
      className={classes.patientName}
      variant="h5"
      noWrap
    >
      {t('common:formattedNameFull', patient)}
    </Typography>
  )
}

export { PatientHeadlineInfo }
